var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 195,
    viewBox: "0 0 179 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.579 76.494C140.901 78.726 146.711 79.9712 154.422 79.9995C167.903 87.8493 174.956 98.7985 177.198 110.809C179.459 122.921 176.841 136.201 170.808 148.561C158.718 173.333 133.139 194 106.711 194C80.0705 194 46.7955 179.992 24.7359 160.869C13.7106 151.312 5.58356 140.559 2.43497 129.752C-0.69438 119.01 1.06878 108.15 9.95818 98.1649C19.1455 87.8449 26.4741 76.5631 33.129 65.4837C35.1378 62.1392 37.0822 58.8188 38.9968 55.5493C43.4416 47.9591 47.7257 40.6432 52.2829 33.9371C58.7915 24.3594 65.7896 16.1336 74.4514 10.2981C83.0936 4.47581 93.4411 1 106.711 1C113.332 1 117.953 2.21595 121.156 4.23991C124.334 6.24805 126.214 9.11276 127.247 12.6259C128.289 16.1675 128.465 20.3547 128.21 24.9406C127.991 28.8784 127.459 33.0426 126.918 37.2817C126.829 37.9777 126.74 38.6757 126.652 39.3751C126.031 44.3116 125.465 49.3051 125.463 54.0033C125.46 58.6997 126.018 63.1734 127.693 67.0526C129.379 70.9586 132.182 74.2232 136.579 76.494Z",
    stroke: "#CBD3FC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse2);
export default __webpack_public_path__ + "static/media/ellipse-2.a690b200e8feb6136c54c7835048424b.svg";
export { ForwardRef as ReactComponent };